import { createStore } from 'redux';
import getMiddlewares from './middlewares';
import reducers from './reducers';

const store = createStore(reducers, getMiddlewares());

export default store;


// WEBPACK FOOTER //
// ./src/store.js